(() => {
  const header = document.querySelector('.site-header');
  const onScroll = () => {
    if (!header) return;
    header.classList.toggle('scrolled', window.scrollY > 10);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });


  document.querySelectorAll('.site-header').forEach((headerEl) => {
    const toggle = headerEl.querySelector('.mobile-menu__toggle');
    const panel = headerEl.querySelector('[data-mobile-menu-panel]');
    const overlay = headerEl.querySelector('[data-mobile-menu-overlay]');
    const close = headerEl.querySelector('.mobile-menu__close');
    if (!toggle || !panel || !overlay) return;

    const openMenu = () => {
      panel.hidden = false;
      overlay.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-menu-open');
    };

    const closeMenu = () => {
      panel.hidden = true;
      overlay.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
    };

    toggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      panel.hidden ? openMenu() : closeMenu();
    });

    overlay.addEventListener('click', closeMenu);
    if (close) close.addEventListener('click', closeMenu);
    panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !panel.hidden) closeMenu();
    });
  });

  document.querySelectorAll('.mobile-menu__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.removeAttribute('open');
    });
  });

  const formatCardPrice = (price, compare) => {
    if (!compare) return `<span>${price}</span>`;
    return `<span>${price}</span><span class="product-card__compare">${compare}</span>`;
  };

  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const image = card.querySelector('[data-product-card-image]');
    const price = card.querySelector('[data-product-card-price]');
    const input = card.querySelector('[data-product-card-variant-input]');

    card.querySelectorAll('[data-card-variant]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        card.querySelectorAll('[data-card-variant]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');

        if (image && button.dataset.image) {
          image.src = button.dataset.image;
          image.removeAttribute('srcset');
        }
        if (input && button.dataset.variantId) input.value = button.dataset.variantId;
        if (price && button.dataset.price) price.innerHTML = formatCardPrice(button.dataset.price, button.dataset.compare || '');
      });
    });
  });

  document.querySelectorAll('[data-main-product-select]').forEach((select) => {
    const section = select.closest('[data-section-type="main-product"]');
    const image = section ? section.querySelector('[data-main-product-image]') : null;
    const price = section ? section.querySelector('[data-main-product-price]') : null;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      if (image && option.dataset.image) {
        image.src = option.dataset.image;
        image.removeAttribute('srcset');
      }
      if (price && option.dataset.price) price.innerHTML = formatCardPrice(option.dataset.price, option.dataset.compare || '');
    });
  });
})();
